import type { AnalyticsEntity } from './revelio-primary-filter-entity-switch';

/**
 * In-memory persistence for the last tab a user opened within each page
 * group (Company, Geography, Role).
 */
const lastViewedTabByEntity = new Map<AnalyticsEntity, string>();

export const getLastViewedTab = (entity: AnalyticsEntity): string | null =>
  lastViewedTabByEntity.get(entity) ?? null;

export const setLastViewedTab = (
  entity: AnalyticsEntity,
  tabId: string
): void => {
  lastViewedTabByEntity.set(entity, tabId);
};
